/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index form-row to autogenerate all the components and extensions
 * Used by "prepareFormRows"
 */

import FormRow from './form-row/FormRow'
export * from './form-row/FormRow'
export default FormRow
